/**
 * Project API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type InvoicingTypeModel = 'TIME_MATERIAL' | 'FIXED_PRICE' | 'PRE_PAID_CARD';

export const InvoicingTypeModel = {
    TimeMaterial: 'TIME_MATERIAL' as InvoicingTypeModel,
    FixedPrice: 'FIXED_PRICE' as InvoicingTypeModel,
    PrePaidCard: 'PRE_PAID_CARD' as InvoicingTypeModel
};

